import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import styles from './Footer.module.css'
import LogoBanner from '../components/LogoBanner'

class Footer extends React.Component {
  frontPage({ data }) {
    return (
      <div>
        <h2 className={styles.footer}>
          Mit Unterstützung von Bund, Land und Europäischer Union
        </h2>
        <div className={styles.footer}>
          <LogoBanner data={data} />
        </div>
        <div className={styles.impressum}>
          <Link to="Impressum">Impressum</Link>
          <br />
          &copy; 2026 AK<br />
          Burgenland
        </div>
      </div>
    )
  }

  contentPage() {
    return (
      <div className={styles.content}>
        <span>
          <span className={styles.content_ort}>
            2026 AK Burgenland | Wiener Strasse 7 7000 Eisenstadt,{' '}
            <span style={{ whiteSpace: 'nowrap' }}>+43 2682 740 0</span>
          </span>
          <Link to="Impressum" className={styles.content_imp}>
            Impressum
          </Link>
        </span>
      </div>
    )
  }

  render() {
    return this.props.isHomepage
      ? this.frontPage(this.props)
      : this.contentPage()
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/layouts/Footer.js